const SYSTEM_NAME = "teashop"

/** 缓存数据时用到的 Key */
class CacheKey {
  static TOKEN = `${SYSTEM_NAME}-token-key`
  static REFRESH_TOKEN = `${SYSTEM_NAME}-refresh-token-key`
  static SIDEBAR_STATUS = `${SYSTEM_NAME}-sidebar-status-key`
  static ACTIVE_THEME_NAME = `${SYSTEM_NAME}-active-theme-name-key`
  static ACTIVE_THEME_COLOR = `${SYSTEM_NAME}-active-theme-color-key`
  static ACTIVE_THEME_FONT = `${SYSTEM_NAME}-active-theme-font-key`
  static ACTIVE_THEME_FONT_SIZE = `${SYSTEM_NAME}-active-theme-font-size-key`
  static ACTIVE_THEME_FONT_WEIGHT = `${SYSTEM_NAME}-active-theme-font-weight-key`
  static ACTIVE_THEME_DENSITY = `${SYSTEM_NAME}-active-theme-density-key`
  static ACTIVE_THEME_DENSITY_SCALE = `${SYSTEM_NAME}-active-theme-density-scale-key`
  static ACTIVE_THEME_SURFACE_EFFECT = `${SYSTEM_NAME}-active-theme-surface-effect-key`
  static ACTIVE_THEME_PROFILE = `${SYSTEM_NAME}-active-theme-profile-key`
  static ACTIVE_THEME_BRIGHTNESS = `${SYSTEM_NAME}-active-theme-brightness-key`
  static ACTIVE_THEME_BRIGHTNESS_ENABLED = `${SYSTEM_NAME}-active-theme-brightness-enabled-key`
  static ACTIVE_THEME_PERFORMANCE_MODE = `${SYSTEM_NAME}-active-theme-performance-mode-key`
  static ACTIVE_THEME_ADVANCED_CONTROLS = `${SYSTEM_NAME}-active-theme-advanced-controls-key`
  static BUSINESS_TABLE_CARD_DENSITY = `${SYSTEM_NAME}-business-table-card-density-key`
  static BUSINESS_TABLE_CARD_DENSITY_LINKED = `${SYSTEM_NAME}-business-table-card-density-linked-key`
  static BUSINESS_PRODUCT_CARD_VIEW_MODE = "tea-shop-2b:business-order:product-card-view-mode"
  static BUSINESS_PRODUCT_CARD_DENSITY_LINKED = `${SYSTEM_NAME}-business-product-card-density-linked-key`
  /** 表格列显示偏好 key 前缀:实际 key 由 createTableColumnPreference 拼上隔离维度 */
  static BILL_DETAIL_V2_COLUMNS_PREFIX = `${SYSTEM_NAME}-bill-detail-v2-columns`
  static HQ_OPERATING_STATISTICS_COLUMNS_PREFIX = `${SYSTEM_NAME}-hq-operating-statistics-columns`
  static IS_PRINT_RECHARGE_BILL = `${SYSTEM_NAME}-is-print-recharge-bill-key`
  static IS_PRINT_CHECKED_BILL = `${SYSTEM_NAME}-is-print-checked-bill-key`
  static APP_VERSION = 'app_version' // 前端应用版本
  static STABLE_VERSION = 'stable_version' // 前端稳定版本

  static NEWEST_VERSION = 'newest_version' // 灰度规则匹配到的最新版本
  static LAST_SYSTEM_VERSION = 'last_system_version' // 上次访问的最新版本
  static UPDATE_NOTICE_NEED_SHOW = 'update_notice_need_show' // 需要展示更新日志的版本信息
  static BUSINESS_ALL_CATEGORY_FLAT_MODE = 'business_all_category_flat_mode' // 营业页全部分类是否平铺展示
}

export default CacheKey
